import styles from "./BuildingEditor.module.scss";

export default function BuildingEditor() {
  return <h2>BUILDING</h2>;
}
